import clsx from 'clsx';
import { IconButton } from '../../components/IconButton';
import { Close, InfoOutlined } from '@material-ui/icons';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { DeviceOption } from './DeviceOption';
import { ActionOptions } from './ActionOptions';
import { DeviceControlProvider } from '../Manage/Account/Devices/DeviceControlContext';

interface Props {
  open: boolean;
  onClose(): void;
}

export const ActionsMenu = ({ open, onClose }: Props) => {
  const { isMobile, devices, setCitrusViewDevice, citrusViewDevice } =
    useCitrusView();

  return (
    <div
      id="quick-action-menu"
      className={clsx(
        'transition-all ease-in-out duration-200 bg-black/80 h-full max-w-[300px] top-0 left-0 absolute overflow-hidden z-[9996]',
        {
          ['w-0 p-0 hidden']: open === false,
          ['w-[30%] block z-[9980]']: open && !isMobile,
          ['w-[40%] py-2 block']: open && isMobile,
        }
      )}
    >
      <div className="inline-flex items-center justify-between w-full overflow-hidden whitespace-nowrap bg-black p-2">
        <p
          className={clsx('text-lg font-bold w-full', {
            '!text-xl': isMobile,
          })}
        >
          Quick Actions
        </p>
        <IconButton className="z-10 pointer-events-auto" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <DeviceControlProvider>
        {devices.length > 1 && citrusViewDevice === undefined && (
          <div className="flex flex-col">
            <div className="flex items-center gap-2 font-bold w-full bg-red-200 text-red-800 px-4 py-1">
              <InfoOutlined fontSize="small" />
              <p>
                <strong>{devices.length}</strong> STB's Found in QASTN
              </p>
            </div>
            <ul className="w-full">
              {devices.map((device) => (
                <DeviceOption
                  key={device.id}
                  device={device}
                  onSelect={() => setCitrusViewDevice(device)}
                />
              ))}
            </ul>
          </div>
        )}
        {citrusViewDevice !== undefined && (
          <DeviceOption
            device={citrusViewDevice}
            onDeselect={
              devices.length > 1 && citrusViewDevice
                ? () => setCitrusViewDevice(undefined)
                : undefined
            }
          />
        )}
      </DeviceControlProvider>
      {citrusViewDevice !== undefined && (
        <>
          <p className="text-xs px-4 py-2 max-w-full">
            Actions may not be visible for 5-10+ seconds depending on latency
            and current buffer.
          </p>
          <ActionOptions device={citrusViewDevice} onClose={onClose} />
        </>
      )}
    </div>
  );
};
